export default __webpack_public_path__ + "static/media/img-for-merchants.be00775b.png";